import { Component } from '@theme/component';

/** Opens Shopify's native modal only after an explicit visitor action. */
class BFCookiePreferences extends Component {
  requiredRefs = ['trigger', 'status'];
  opening = false;

  connectedCallback() {
    super.connectedCallback();
    this.refs.trigger.disabled = false;
  }

  updatedCallback() {
    super.updatedCallback();
    this.refs.trigger.disabled = false;
  }

  async openPreferences() {
    const { trigger, status } = this.refs;
    if (trigger.disabled || this.opening) return;
    this.opening = true;
    status.textContent = '';
    trigger.setAttribute('aria-busy', 'true');
    try {
      // Documented Shopify Cookie Banner API. Never write consent ourselves.
      if (typeof window.privacyBanner?.showPreferences !== 'function') {
        throw new Error('Shopify cookie preferences are unavailable');
      }
      await window.privacyBanner.showPreferences();
    } catch {
      if (this.isConnected) {
        status.textContent = status.dataset.error;
        trigger.focus();
      }
    } finally {
      this.opening = false;
      if (this.isConnected) trigger.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('bf-cookie-preferences')) {
  customElements.define('bf-cookie-preferences', BFCookiePreferences);
}
